import React, { useEffect, useState, useRef } from 'react';
import { generateSecret, decryptAesCbc } from '../../utils/cryptoLegacy';
import getDomain from '../PaymentMode/Components/getDomain';
import { startGlomopayCheckout } from './glomopayCheckout';

function SecureInitiatePayment() {
  const [gateway, setGateway] = useState('');
  const [orderId, setOrderId] = useState('');
  const [error, setError] = useState('');
  const [ready, setReady] = useState(true);
  const [apiData, setApiData] = useState(null);


  useEffect(() => {
    (async () => {
      try {
      debugger;
        // Read query params from URL
        const queryParameters = new URLSearchParams(window.location.search);
        const orderNo = queryParameters.get('orderNo');
        const var1 = queryParameters.get('var1');
        const var2 = queryParameters.get('var2');

        // Fetch non-seamless details from backend
        const temp = { orderNo: orderNo };
        const response = await fetch(`/pay/securePayment/details/nonSeamless?var1=${encodeURIComponent(var1)}&var2=${encodeURIComponent(var2)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(temp),
        });
        if (!response.ok) {
          throw new Error('Failed to fetch payment details.');
        }
        const data = await response.json();
        setApiData(data);

        const gw = (data?.gateway || '').toLowerCase().trim();
        setGateway(gw);

        if (gw !== 'glomopay') {
          // for now only supports glomopay
          return;
        }
      } catch (e) {
        setError(e?.message || 'Failed to prepare payment parameters.');
      }
    })();
  }, []);

  // Auto-open GlomoPay checkout once ready; guard against double-invoke
  const launchedRef = useRef(false);
  useEffect(() => {
    if (gateway === 'glomopay' && !launchedRef.current) {
      launchedRef.current = true;
      startGlomopayCheckout(apiData).catch(() => {
        launchedRef.current = false;
        setError('Unable to start GlomoPay checkout.');
      });
    }
  }, [ready, gateway, apiData]);

  if (error) {
    return (
      <div style={{ padding: 16, color: '#b00020', fontFamily: 'sans-serif' }}>
        {error}
      </div>
    );
  }

  if (gateway && gateway !== 'glomopay') {
    return <div style={{ padding: 16, fontFamily: 'sans-serif' }}>Redirecting…</div>;
  }

  return (
    <div style={{ padding: 16 }}>
      {gateway === 'glomopay' ? (
        <div style={{ fontFamily: 'sans-serif' }}>
          {ready ? '' : ''}
        </div>
      ) : null}
    </div>
  );
}

export default SecureInitiatePayment;



